<template>
  <v-autocomplete
    color="primary"
    v-model="brandsSelected"
    :clearable="!unclearable"
    chips
    multiple
    deletable-chips
    small-chips
    :items="brand"
    :loading="brandsLoading"
    :search-input.sync="brandsSearch"
    item-text="key"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('CurrentStocks.brand')"
    :return-object="returnId ? false : true"
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :hint="hint"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-if="errorHint" v-slot:message="{ key, message }">
      <div :class="key == 0 ? 'danger--text' : ''">
        {{ message }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import Materials from "@/api/materials";

export default {
  name: "SearcherBrands",

  props: {
    value: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    hint: String,
    errorHint: Boolean,
    returnId: Boolean,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    brand: [],
    brandsLoading: false,
    brandsSearch: "",
    brandsSelected: [],
  }),

  mounted() {
    this.brandsLoading = true;
    Materials.fetchFiledSelects({field_name:'brand'})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.brand = response.data.brand;
          }
          this.brandsLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.brandsLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.brandsSelected = this.value;
      },
    },
    brandsSelected: {
      handler() {
        this.$emit("input", this.brandsSelected);
      },
    },
  },
};
</script>
